<script lang="ts">
import { onMount } from "svelte";
import { toast } from "svelte-sonner";
import { t } from "$lib/i18n";

async function detectSWUpdate() {
  const registration = await navigator.serviceWorker.ready;

  registration.addEventListener("updatefound", () => {
    const newSW = registration.installing;

    if (newSW) {
      newSW.addEventListener("statechange", () => {
        if (newSW.state === "installed") {
          toast($t("reloadPrompt.message"), {
            duration: Infinity,
            action: {
              label: $t("reloadPrompt.refresh"),
              onClick: () => {
                newSW.postMessage({ action: "skipWaiting" });
                window.location.reload();
              },
            },
          });
        }
      });
    }
  });
}

onMount(() => {
  detectSWUpdate();
});
</script>
